import React, { Component, Fragment} from 'react'
import StyleSheet from 'styles'
import LockIcon from '@material-ui/icons/Lock'
import Button from '@material-ui/core/Button'
import { Authorization } from 'utils/AuthorizationUtils'
import { withRouter } from 'react-router-dom'

export class Lock extends Component {
  renderReason = () =>{
    if(!Authorization.user.id){
      return (
        <Fragment>
          <p>Please sign up to unlock the contents including Issuance info, Post-sale activity, Whitepaper, Research and Risk report</p>
          <Button color="primary" variant="contained" onClick={() => this.props.history.push(`/tokens/sign_up`)}>Sign up</Button>
        </Fragment>
      )
    }else if(!Authorization.approved){
      return (
        <Fragment>
          <p>Please get verified to unlock the contents including Issuance info, Post-sale activity, Whitepaper, Research and Risk report</p>
          <Button color="primary" variant="contained" onClick={() => this.props.history.push(`/investor/${Authorization.user.id}/edit`)}>Get Verified</Button>
        </Fragment>
      )
    }

    return (
      <p>Sorry you are not eligible to see the restricted information for this deal</p>
    )
  }

  render = () =>
    <div className={styles.lockContainer}>
      <div className={styles.lockContent}>
        <LockIcon />
        {this.renderReason()}
      </div>
    </div>
}

const styles = StyleSheet({
  lockContainer: {
    position: 'absolute',
    top: -30, right: -30, bottom: -30, left: -30,
    backgroundColor: 'rgba(216, 216, 216, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lockContent: {
    width: 390,
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '24px',
    '& svg': {
      fill: '#a4a4a4',
      width: '60px',
      height: '60px',
    },
    '& p': {
      marginTop: 5,
      marginLeft: 30,
      marginRight: 30,
    },
    '& button': {
      width: 250
    }
  }
})

export default withRouter(Lock)